<template>
  <v-dialog
    v-model="dialog"
    @close="handleClose"
    @click:outside="handleClose"
    width="400"
    contentClass="rounded-xl"
    :persistent="loading"
  >
    <v-card class="pa-4">
      <h4 class="lh-2">Finalizar venda</h4>

      <v-card outlined class="pa-4 mt-4 d-flex flex-column align-center">
        <h6 class="mb-0">Receba do cliente</h6>
        <h2 class="mb-0">
          {{ (amount + fee?.amount) | currency }}
        </h2>
        <small v-if="fee?.amount > 0">
          {{ amount | currency }} + Taxa: {{ fee?.amount | currency }}
        </small>
      </v-card>
      <v-card outlined class="pa-4 pt-2 mt-4">
        <p class="mb-2 font-weight-bold">Forma de Pagamento</p>
        <div class="gap-3 d-flex align-center">
          <v-icon>
            {{ paymentMethod.icon }}
          </v-icon>
          <h5 class="mb-0">{{ paymentMethod.name }}</h5>
        </div>
      </v-card>
      <v-alert v-if="error" type="error" class="mt-4">
        {{ error }}
      </v-alert>
      <div class="d-flex justify-space-between align-end mt-4">
        <v-btn
          depressed
          text
          @click="handleClose"
          :disabled="loading"
        >
          Cancelar
        </v-btn>
        <v-btn
          large
          depressed
          color="primary"
          :loading="loading"
          @click="confirmPayment"
        >
          Confirmar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import VIRTUAL_POS from "@/services/staff/virtualPos";
export default {
  name: "PaymentConfirm",
  components: {},
  props: {
    token: {
      type: Object,
      required: true,
    },
    payment: {
      type: Object,
      required: false,
    },
    paymentMethod: {
      type: Object,
      required: false,
    },
    amount: {
      type: Number,
      required: false,
    },
    fee: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
      promisse: null,
      loading: false,
      error: null,
      paymentTypeTranslate: {
        pix: "PIX",
        money: "MONEY",
        debit: "DEBIT_CARD",
        credit: "CREDIT_CARD",
        courtesy: "COURTESY",
      },
    };
  },
  methods: {
    async confirmPayment() {
      try {
        this.loading = true;
        this.error = null;
        const response = await VIRTUAL_POS.approvePayment(
          this.token,
          this.payment.id,
          {
            amount: this.amount + (this.fee?.amount || 0),
            paymentType:
              this.paymentTypeTranslate[this.paymentMethod.id] || undefined,
            extraData: {},
            integrationId: "",
          }
        );
        this.promisse.resolve(response);
        this.promisse = null;
        this.loading = false;
        this.handleClose();
      } catch (error) {
        console.error("Error confirming payment:", error);
        this.error = error.message || "Erro ao confirmar pagamento.";
        this.loading = false;
      }
    },
    confirm() {
      return new Promise((resolve, reject) => {
        this.promisse = { resolve, reject };
        this.open();
      });
    },
    open() {
      this.dialog = true;
    },
    handleClose() {
      if (this.loading) return;
      this.dialog = false;
      if (this.promisse) {
        this.promisse.reject();
        this.promisse = null;
      }
    },
  },
};
</script>
